module.exports = __webpack_public_path__ + "assets1775130923925/img/error-401.98bba5b1.svg";